/**
 * Created by Daniela on 19/12/2016.
 */
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { UtilService } from "../../../shared/services/util.service";
import {alarmeModuleName} from "../shared/data.service";
import { configuracaoModuleName, editRoute, newRoute } from "../../../shared/services/data.service";
import {Alarme} from "../shared/alarme.model";
import { AlarmeApiService } from "../shared/alarme-api.service";
import { Alarmeservice } from "../shared/alarme.service";
import { AlarmeNavigationService } from "../shared/alarme-navigation.service";
import { RastreamentoService } from "../../shared/rastreamento.service";
import { rastreamentosModuleName } from "../../shared/data.service";
import {FrotaApiService} from "../../../bens/frotas/shared/frota-api.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {frotasQueryComGPS} from "../../../bens/frotas/shared/data.service";
import {CercaApiService} from "../../cercas/shared/cerca-api.service";
import {EmailValidator} from "../../../shared/validators/email.validation";
import {TemplateApiService} from "../../templates/template-api.service";
import {TemplateService} from "../../templates/template.service";

@Component({
    template: require('./alarme-form.component.html'),
    styles: [require('./alarme-form.component.css')]
})
export class AlarmeFormComponent implements OnInit, AfterViewInit {
    alarmeModule:any = alarmeModuleName;
    formObject:any = new Alarme();
    actionTitle:string;
    submitted:boolean = false;
    submitted2:boolean = false;
    btnSaveDisabled:boolean = false;
    configuracaoModule: any = configuracaoModuleName;
    module: any = rastreamentosModuleName;

    loadingEvent: boolean = true;
    eventsList: any[] = [];
    eventObject: any = {};
    loadingBens: boolean = true;
    bensList: any[] = [];
    bensObject: any[] = [];
    loadingCercas: boolean = true;
    cercasList: any[] = [];
    cercasObject: any[] = [];
    emailsObject: any[] = [];
    emailString: string;
    templateObject: any = {};

    form:FormGroup;
    ativo = new FormControl('');
    titulo = new FormControl('', Validators.required);
    tipoEvento = new FormControl('', Validators.required);
    minimoVelocidade = new FormControl('');
    maximoVelocidade = new FormControl('');
    bens = new FormControl([]);
    cercas = new FormControl([]);

    form2: FormGroup;
    email = new FormControl('', Validators.compose([Validators.required, EmailValidator.emailFormat]));

    private tabSelected: string = 'bens';
    private cloneBensObject: any[] = [];
    private cloneCercasObject: any[] = [];
    private cloneEmailsObject: any[] = [];

    constructor(
        private _route:ActivatedRoute,
        private _utilService:UtilService,
        private _alarmeservice: Alarmeservice,
        private _alarmeApiService: AlarmeApiService,
        private _alarmeNavigationService: AlarmeNavigationService,
        private _rastreamentoService: RastreamentoService,
        private _frotaApiService: FrotaApiService,
        private _frotaService: FrotasService,
        private _cercaApiService: CercaApiService,
        private _templateApiService: TemplateApiService,
        private _templateService: TemplateService,
        private _fb:FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            titulo: this.titulo,
            tipoEvento: this.tipoEvento,
            minimoVelocidade: this.minimoVelocidade,
            maximoVelocidade: this.maximoVelocidade,
            bens: this.bens,
            cercas: this.cercas
        });

        this.form2 = _fb.group({
            email: this.email
        });
    }

    ngOnInit() {
        this.getEvents();
        this.getFrotas();
        this.getCercas();

        this.testSession();
    }

    ngAfterViewInit() {
        this.formObject.ativo = true;
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.goToList();
    }

    clickSubmit() {
        $('#submitForm').click();
    }

    clickGoToConfig() {
        this._rastreamentoService.goToSetting();
    }

    setTab(tab:string) {
        this.tabSelected = tab;
    }

    isTab(tab: string) {
        return (tab === this.tabSelected);
    }

    clickRemoveEmail(index: number) {
        this.emailsObject.splice(index, 1);
    }

    changeEvent() {
        if (this.eventObject.id) {
            this.getTemplateByEvent();
        }
    }

    onSubmit(evt: any) {
        this.submitted = true;

        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object:any = this._utilService.cloneObject(this.formObject);

            if (this.eventObject.id) {
                object.tipoEvento = this.eventObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.templateObject.id) {
                object.templateId = this.templateObject.id;
            }


            object.Bens = this.formatOptionsAlarme(this.bensObject, this.cloneBensObject, 'bemId', 'id');
            object.Cercas = this.formatOptionsAlarme(this.cercasObject, this.cloneCercasObject, 'cercaProjetoId', 'id');
            object.Emails = this.formatOptionsAlarme(this.emailsObject, this.cloneEmailsObject, 'email', 'email');

            if (this.formObject.id) {
                this.onEditAlarme(object);
            } else {
                this.onAddAlarme(object);
            }
        }
    }

    onSubmit2(evt: any) {
        this.submitted2 = true;
        if(evt.valid) {
            this.emailsObject.push({ativo: true, email: this.emailString});
            this.submitted2 = false;
        }
    }

    private onAddAlarme(object: Alarme) {
        this._alarmeApiService.onPost(object, this.onDone);
    }

    private onEditAlarme(object: Alarme) {
        this._alarmeApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }
            this.goToList();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getTemplateByEvent() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                if (Response.length) {
                    this.templateObject = Response[0];
                } else {
                    this._utilService.swalMessageWarningCustom("Nenhuma template encontrada para o evento selecionado!");
                }
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        const query = {
            where: {
                tipoEvento: this.eventObject.id
            }
        };
        this._templateApiService.onGetByQuery(query, onDone);
    }

    private getObject(id: number) {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum alarme encontrado com este id.');
                this.goToList();
            }
        }.bind(this));

        this._alarmeApiService.onGetById(id, onDone);
    }

    private getEvents() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.eventsList = Response;
                this.setEvent();
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }

            this.loadingEvent = false;
        }.bind(this));

        this._alarmeApiService.onGetEvents(onDone);
    }

    private getFrotas() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.bensList = Response;

                if (this.bensObject.length) {
                    this.setOptionsAlarme(this.bensList, this.bensObject, 'bemId');
                }
            }
            this.loadingBens = false;
        }.bind(this));

        let query: any = this._utilService.cloneObject(frotasQueryComGPS);
        query.where.ativo = true;
        const veiculoCategoriaId = this._frotaService.getTipoVeiculo();
        this._frotaApiService.onGetByCategoriaQuery(veiculoCategoriaId, query, onDone);
    }

    private getCercas() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number, list: any[] = [];
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }
                this.cercasList = list;

                if (this.cercasObject.length) {
                    this.setOptionsAlarme(this.cercasList, this.cercasObject, 'cercaProjetoId');
                }
            }
            this.loadingCercas = false;
        }.bind(this));

        this._cercaApiService.onGetAll(onDone);
    }

    private getBensAlarme(alarmeId: number) {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.bensObject = Response;
                this.cloneBensObject = this._utilService.cloneObject(Response);
                this.setOptionsAlarme(this.bensList, this.bensObject, 'bemId');
            }
        }.bind(this));

        const query: any = {
            where: {
                ativo: true,
                alarmeId: alarmeId
            }
        };
        this._alarmeApiService.onGetByQueryBemAlarme(query, onDone);
    } 
    
    private getCercasAlarme(alarmeId: number) {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.cercasObject = Response;
                this.cloneCercasObject = this._utilService.cloneObject(Response);
                this.setOptionsAlarme(this.cercasList, this.cercasObject, 'cercaProjetoId');
            }
        }.bind(this));

        const query: any = {
            where: {
                ativo: true,
                alarmeId: alarmeId
            }
        };
        this._alarmeApiService.onGetByQueryCercaAlarme(query, onDone);
    }

    private getEmailsAlarme(alarmeId: number) {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.emailsObject = Response;
                this.cloneEmailsObject = this._utilService.cloneObject(Response);
            }
        }.bind(this));

        const query: any = {
            where: {
                ativo: true,
                alarmeId: alarmeId
            }
        };
        this._alarmeApiService.onGetByQueryEmailAlarme(query, onDone);
    }

    private setEvent() {
        let x: any, lenX: any,
            t: number = this.eventObject.id;

        if (!t) {
            t = this.eventsList[0].id;
        }
        for (x = 0, lenX = this.eventsList.length; x < lenX; x++) {
            if (this.eventsList[x].id === t) {
                this.eventObject = this.eventsList[x];
                break;
            }
        }
    }

    private setModelToForm() {
        if (this.formObject.tipoEvento) {
            this.eventObject = {id: this.formObject.tipoEvento};
            this.setEvent();
        }

        delete this.formObject['template'];
    }

    private setOptionsAlarme(list1: any[], list2: any[], compare: any) {
        let x: number, lenX: number, y: number, lenY: number;
        for (x = 0, lenX = list1.length; x < lenX; x++) {
            for (y = 0, lenY = list2.length; y < lenY; y++) {
                if (list1[x].id === list2[y][compare]) {
                    list2[y] = list1[x];
                    break;
                }
            }
        }
    }

    private formatOptionsAlarme(objectList: any[], clone: any[], att1: string, att2: string) {
        let x: any, lenX: any,
            y: number, lenY: number,
            notFound: boolean,
            e: any,
            newList = [];

        if (objectList.length) {
            //se tiver no clone e object = n faz nada
            //se tiver somente no object = add
            //se nao tiver objeto e tiver no clone = remove

            //add os elementos que permanecem/ou sao novos
            for (x = 0, lenX = objectList.length; x < lenX; x++) {
                newList.push({
                    ativo: true,
                    [att1]: objectList[x][att2]
                });
            }

            for (x = 0, lenX = clone.length; x < lenX; x++) {
                notFound = true;
                for (y = 0, lenY = newList.length; y < lenY; y++) {
                    //add os elementos q ja estao cadastrados
                    if (clone[x][att1] === newList[y][att1]) {
                        notFound = false;
                        newList[y] = clone[x];
                        break;
                    }
                }

                //add os que serao removidos para serem editados passando ativo=false
                if (notFound) {
                    e = clone[x];
                    e.ativo = false;
                    newList.push(e);
                }
            }


        } else {
            //se for para remover todos os itens
            for (x = 0, lenX = clone.length; x < lenX; x++) {
                e = clone[x];
                e.ativo = false;
                newList.push(e);
            }
        }

        return newList;
    }

    private goToList() {
        this._alarmeservice.clearSessionStorage();
        this._alarmeNavigationService.goToList();
    }

    private testSession() {
        let id: number = +this._route.snapshot.params['id'];
        if (id) {
            this.actionTitle = editRoute;
            this.getObject(id);
            this.getBensAlarme(id);
            this.getCercasAlarme(id);
            this.getEmailsAlarme(id);
        } else {
            this.actionTitle = newRoute;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/alarmes/alarme-form/alarme-form.component.ts
 **/